import React, { useEffect, useState } from "react";
import ImagePopupModal from "./ImagePopupModal";
import ConfirmationModal from "../../shareableContainer/ConfirmationModal";
import { getIcons } from "../../Constant/Constant";
import CPManageService from "../../Services/CPManageService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";

const MemberLeadDetailModal = ({ selectedMember, onClose }) => {
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const [profileCompletion, setProfileCompletion] = useState(90);
  const [selectedTab, setSelectedTab] = useState("all");
  const [isActive, setIsActive] = useState(selectedMember?.active);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [maxLeadCount, setMaxLeadCount] = useState(0);
  const [confirmationData, setConfirmationData] = useState({
    title: "",
    message: "",
    action: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageId, setNextPageId] = useState(null);
  const [previousPageId, setPreviousPageId] = useState(null);
  const [pages, setPages] = useState([]);
  const [hasMoreLeads, setHasMoreLeads] = useState(true);
  const [leadCache, setLeadCache] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  console.log("Member ", selectedMember?.uid);

  const icons = getIcons();

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const userId = userObj?.user?.uid;
  const userUid = selectedMember?.uid;

  const getUserLeadDetails = async (
    nextId = null,
    direction = null,
    tabType = null
  ) => {
    setLoading(true);

    const cacheKey = `${nextId}-${tabType}`;
    console.log("Fetching leads with tabType:", tabType);

    if (leadCache[cacheKey]) {
      setLeadData(leadCache[cacheKey].leads);
      setNextPageId(leadCache[cacheKey].next);
      setPreviousPageId(leadCache[cacheKey].prev);
      setMaxLeadCount(leadCache[cacheKey].maxCount || 0);
      setLoading(false);
      return;
    }

    try {
      let leadStatus = null;
      if (tabType === "converted") {
        leadStatus = true;
      } else if (tabType === "all") {
        leadStatus = null;
      }

      console.log("Calling API with leadStatus:", leadStatus);

      const response = await CPManageService.getUserByLead(
        userUid,
        nextId,
        direction,
        leadStatus
      );

      console.log("Response from CPManageService:", response);

      if (response?.status === 204) {
        console.warn("No leads found (404), setting empty data.");
        setLeadData([]);
        setNextPageId(null);
        setPreviousPageId(null);
        setMaxLeadCount(0);
      }
      if (response?.data) {
        const newLeads = response.data.leads || [];
        setLeadData(newLeads);
        setNextPageId(response.data?.next);
        setPreviousPageId(response.data?.previous);
        setMaxLeadCount(response.data?.maxLeadCount);
        setLeadCache((prevCache) => ({
          ...prevCache,
          [cacheKey]: {
            leads: newLeads,
            next: response.data?.next,
            prev: response.data?.previous,
            maxCount: response.data?.maxLeadCount,
          },
        }));
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        console.warn("No leads found (404), setting empty data.");
        setLeadData([]);
        setNextPageId(null);
        setPreviousPageId(null);
        setMaxLeadCount(0);
      } else {
        console.error("Error fetching user lead details:", error);
      }
      console.error("Error fetching user lead details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchLead = async () => {
    console.log("Searching for leads with term:", searchTerm);
    setSearchTerm(searchTerm);
    setLoading(true);
    const body = {
      searchKey: searchTerm ,
      uid: userUid,
      type : selectedTab == "all" ? 1 : selectedTab == "converted" ? 2 : 3 ,
    };

    if (searchTerm === "") {
      getUserLeadDetails();
    } else {
      try {
        const response = await CPManageService.CPLeadSearch(body);
        console.log("Response from CPManageService:", response);
        if (response?.data) {
          const newLeads = response.data.leads || [];
          setLeadData(newLeads);
          setNextPageId(response.data?.next);
          setPreviousPageId(response.data?.previous);
          setMaxLeadCount(response.data?.maxLeadCount);
          setLeadCache({});
          setLoading(false);
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setLeadData([]);
        }
        
        console.error("Error searching leads:", error);
      }
    }
  };

  const LPAGE = 10;

  const handlePageChange = (pageId, direction) => {
    const totalPages = Math.ceil(maxLeadCount / LPAGE);
    console.log("Total pages:", totalPages);

    if (!pageId || (direction === "next" && currentPage === totalPages)) return;

    setCurrentPage((prev) => (direction === "next" ? prev + 1 : prev - 1));
    getUserLeadDetails(pageId, direction, selectedTab);
  };

  useEffect(() => {
    console.log("Selected tab changed:", selectedTab);
    setCurrentPage(1);
    setNextPageId(null);
    setPreviousPageId(null);
    getUserLeadDetails(null, null, selectedTab);
  }, [selectedTab]);

  const calculateProfileCompletion = (member) => {
    if (!member) return 0;

    const requiredFields = [
      member.name,
      member.phoneNumber,
      member.emailId,
      member.alternatePhoneNumber,
      member.aadhaarCardImageUrl,
      member.panCardImageUrl,
      member.passbookImageUrl,
      member.onBoardedDate,
    ];

    const filledFields = requiredFields.filter(
      (field) => field && field.trim() !== ""
    ).length;

    return Math.round((filledFields / requiredFields.length) * 100);
  };

  useEffect(() => {
    if (selectedMember) {
      setProfileCompletion(calculateProfileCompletion(selectedMember));
    }
  }, [selectedMember]);

  const openImagePopup = (imageType) => {
    const imagePlaceholders = {
      aadhar: selectedMember?.aadhaarCardImageUrl,
      pan: selectedMember?.panCardImageUrl,
      passbook: selectedMember?.passbookImageUrl,
    };

    setCurrentImage({
      url: imagePlaceholders[imageType] || "/api/placeholder/400/300",
      type: imageType,
    });
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setShowImagePopup(false);
    setCurrentImage(null);
  };

  const handleToggleClick = () => {
    const newStatus = !isActive;
    setShowConfirmation(true);
    setConfirmationData({
      title: `${newStatus ? "Activate" : "Deactivate"} Member?`,
      message: `Are you sure you want to ${
        newStatus ? "activate" : "deactivate"
      } this member?`,
      action: "toggleStatus",
    });
  };

  const handleConfirmAction = async () => {
    if (confirmationData.action === "toggleStatus") {
      setIsActive(!isActive);
      try{
        const body = {
          id:selectedMember?.uid,
          active: !isActive
        }
        const response = await CPManageService.CPUserStatusChange(body)
        if (response.status === 200) {
        showSuccessToast("Member status updated successfully");
          }
          } catch (error) {
            showErrorToast("Failed to update member status");
            }
          
      }
    
    setShowConfirmation(false);
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchLead();
    }
  };

  return (
    <>
      {!showImagePopup && !showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[1160px] h-[640px] overflow-hidden shadow-xl">
            <div className="p-5">
              <div className="mb-6 flex items-center gap-14 ">
                <div className="flex w-full items-center justify-between border-2 border-slate-200 px-3 py-4 rounded-2xl">
                  <div className="flex justify-between items-center space-x-2">
                    <span className="text-green-600 font-medium">
                      Onboard Date: {selectedMember?.onBoardedDate}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-orange-500 font-medium mr-4">
                      {profileCompletion}% Profile Completed
                    </span>
                    <span className={isActive ? "" : "text-red-600"}>
                      {isActive ? "Disable" : "Disable"}
                    </span>
                    <label
                      className="inline-flex items-center cursor-pointer"
                      onClick={handleToggleClick}
                    >
                      <div className="relative">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={isActive}
                          readOnly
                        />
                        <div className="w-11 h-6 bg-gray-200 rounded-full"></div>
                        <div
                          className={`absolute left-1 top-1  w-4 h-4 rounded-full transition-transform ${
                            isActive
                              ? "translate-x-5 bg-green-500"
                              : " bg-red-500 translate-x-0"
                          }`}
                        ></div>
                      </div>
                    </label>
                    <span
                      className={isActive ? "text-green-600" : "text-black"}
                    >
                      {isActive ? "Accept" : "Accept"}
                    </span>
                  </div>
                </div>
                <button onClick={onClose} className="text-2xl font-bold">
                  X
                </button>
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white rounded-[20px] px-[40px] py-4 border w-full mx-4">
                  <div className="mb-6 space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-gray-700 font-medium">Name</p>
                        <div className="bg-gray-100 truncate p-3 rounded-md">
                          {selectedMember.name}
                        </div>
                      </div>
                      <div>
                        <p className="text-gray-700 font-medium">
                          Phone Number
                        </p>
                        <div className="bg-gray-100 p-3 rounded-md">
                          {selectedMember.phoneNumber || "+91 xxxxxxxxxx"}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-gray-700 font-medium">Email</p>
                        <div
                          title={selectedMember?.emailId}
                          className="bg-gray-100 cursor-pointer truncate p-3 rounded-md"
                        >
                          {selectedMember.emailId || "member@gmail.com"}
                        </div>
                      </div>
                      <div>
                        <p className="text-gray-700 font-medium">
                          Alternate Phone Number
                        </p>
                        <div className="bg-gray-100 p-3 rounded-md">
                          {selectedMember.alternatePhoneNumber ||
                            "+91 xxxxxxxxxx"}
                        </div>
                      </div>
                    </div>
{/* 
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-gray-700 font-medium">
                          Aadhar Card Image
                        </p>
                        <div className="bg-gray-100 p-3 rounded-md">
                          <a
                            onClick={
                              selectedMember?.aadhaarCardImageUrl
                                ? () => openImagePopup("aadhar")
                                : undefined
                            }
                            className={` hover:underline ${
                              selectedMember?.aadhaarCardImageUrl
                                ? "cursor-pointer text-blue-500"
                                : "cursor-not-allowed text-red-500"
                            }`}
                          >
                            {selectedMember?.aadhaarCardImageUrl
                              ? "View Image"
                              : "No Image"}
                          </a>
                        </div>
                      </div>
                      <div>
                        <p className="text-gray-700 font-medium">
                          Pan card Image
                        </p>
                        <div className="bg-gray-100 p-3 rounded-md">
                          <a
                            onClick={
                              selectedMember?.panCardImageUrl
                                ? () => openImagePopup("pan")
                                : undefined
                            }
                            className={`hover:underline ${
                              selectedMember?.panCardImageUrl
                                ? "cursor-pointer text-blue-500"
                                : "cursor-not-allowed text-red-500"
                            }`}
                          >
                            {selectedMember?.panCardImageUrl
                              ? "View Image"
                              : "No Image"}
                          </a>
                        </div>
                      </div>
                    </div>

                    <div>
                      <p className="text-gray-700 font-medium">
                        Passbook Image
                      </p>
                      <div className="bg-gray-100 p-3 rounded-md">
                        <a
                          onClick={
                            selectedMember?.passbookImageUrl
                              ? () => openImagePopup("passbook")
                              : undefined
                          }
                          className={` hover:underline ${
                            selectedMember?.passbookImageUrl
                              ? "cursor-pointer text-blue-500"
                              : "cursor-not-allowed text-red-500"
                          }`}
                        >
                          {selectedMember?.passbookImageUrl
                            ? "View Image"
                            : "No Image"}
                        </a>
                      </div>
                    </div> */}

                    {selectedMember?.isParallelyWorking && (
                      <div>
                        <p className="text-gray-700 font-medium">
                          Are you working for another company
                        </p>
                        <div className="bg-gray-100 p-3 rounded-md">
                          {selectedMember.parallelCompanies || "Company Name"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right side - Leads */}
                <div className="space-y-5">
                  <div>
                    <div className="flex justify-start gap-6 mb-4">
                      <span
                        className={`border-2 px-4 py-3 rounded-xl cursor-pointer ${
                          selectedTab === "all"
                            ? "text-green-800"
                            : "bg-gray-100"
                        }`}
                        onClick={() => setSelectedTab("all")}
                      >
                        All Leads {selectedTab == "all" ? maxLeadCount : ""}
                      </span>
                      <span
                        className={`border-2 px-4 py-3 rounded-xl cursor-pointer ${
                          selectedTab === "converted"
                            ? "text-green-800"
                            : "bg-gray-100"
                        }`}
                        onClick={() => setSelectedTab("converted")}
                      >
                        Converted{" "}
                        {selectedTab === "converted" ? maxLeadCount : ""}
                      </span>
                    </div>

                    <div className="mt-4">
                      <div className="flex item gap-3">
                        <input
                          className="border-customGreen rounded-md border bg-transparent  h-10     px-3 focus:outline-none"
                          placeholder="Search by name or phone number"
                          type="search"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          onKeyPress={handleSearchKeyPress}
                        />

                        <button
                          onClick={handleSearchLead}
                          className="w-40 border-2 text-white bg-customGreen  rounded-lg p-2"
                        >
                          Search
                        </button>
                      </div>

                      <div className="mt-4 space-y-3 max-h-[340px] overflow-y-auto">
                        {!loading ? (
                          leadData.length > 0 ? (
                            leadData.map((lead, index) => (
                              <div
                                key={index}
                                className="bg-white border-2 rounded-[15px] p-3 shadow-sm"
                              >
                                <div className="font-medium">{lead.name}</div>
                                <div className="text-sm text-gray-600">
                                  +{lead?.countryCode}
                                  {lead.phoneNumber}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center py-4 text-gray-500">
                              No leads found
                            </div>
                          )
                        ) : (
                          <div className="flex items-center justify-center mt-14 text-gray-600 font-medium">
                            <div className="spinner"></div>
                          </div>
                        )}
                      </div>
                      <div className="flex justify-center my-5 gap-10">
                        {currentPage > 1 && (
                          <button
                            onClick={() =>
                              handlePageChange(previousPageId, "previous")
                            }
                            className={`mx-1 px-3 py-1 border rounded text-blue-500 ${
                              !previousPageId || currentPage === 1
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            disabled={!previousPageId || currentPage === 1}
                          >
                            <img
                              src={icons.previousPagination}
                              className="w-3"
                              alt="Previous"
                            />
                          </button>
                        )}

                        {leadData.length === LPAGE && (
                          <span>{currentPage}</span>
                        )}

                        {leadData.length === LPAGE &&
                          currentPage * LPAGE < maxLeadCount && (
                            <button
                              onClick={() =>
                                handlePageChange(nextPageId, "next")
                              }
                              className={`mx-1 px-3 py-1 border rounded text-blue-500 ${
                                !nextPageId
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                              disabled={
                                !nextPageId ||
                                currentPage * LPAGE >= maxLeadCount
                              }
                            >
                              <img
                                src={icons.nextPagination}
                                className="w-3"
                                alt="Next"
                              />
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImagePopup && (
        <ImagePopupModal
          showModal={showImagePopup}
          imageData={currentImage}
          onClose={closeImagePopup}
        />
      )}

      {showConfirmation && (
        <ConfirmationModal
          showModal={showConfirmation}
          icon={icons?.confirmationWarning}
          title={confirmationData.title}
          message={confirmationData.message}
          onConfirm={handleConfirmAction}
          onCancel={handleCancelConfirmation}
        />
      )}
    </>
  );
};

export default MemberLeadDetailModal;
